/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { HelpData } from './HelpData'
import {
  HelpDataFromJSON,
  HelpDataFromJSONTyped,
  HelpDataToJSON,
} from './HelpData'
import type { HelpType } from './HelpType'
import {
  HelpTypeFromJSON,
  HelpTypeFromJSONTyped,
  HelpTypeToJSON,
} from './HelpType'

/**
 *
 * @export
 * @interface GetHelpRequest
 */
export interface GetHelpRequest {
  /**
   * Тип внешней формы
   * @type {HelpType}
   * @memberof GetHelpRequest
   */
  type: HelpType
  /**
   * Данные формы — поля зависят от конфигурации (динамическая валидация)
   * @type {HelpData}
   * @memberof GetHelpRequest
   */
  data: HelpData
}

/**
 * Check if a given object implements the GetHelpRequest interface.
 */
export function instanceOfGetHelpRequest(
  value: object
): value is GetHelpRequest {
  if (!('type' in value) || value['type'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetHelpRequestFromJSON(json: any): GetHelpRequest {
  return GetHelpRequestFromJSONTyped(json, false)
}

export function GetHelpRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetHelpRequest {
  if (json == null) {
    return json
  }
  return {
    type: HelpTypeFromJSON(json['type']),
    data: HelpDataFromJSON(json['data']),
  }
}

export function GetHelpRequestToJSON(value?: GetHelpRequest | null): any {
  if (value == null) {
    return value
  }
  return {
    type: HelpTypeToJSON(value['type']),
    data: HelpDataToJSON(value['data']),
  }
}
